import {
  EventEmitter,
  Component,
  OnInit,
  Output,
  Input,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild,
  AfterViewInit,
  HostListener,
} from "@angular/core";
import { ProductsMenu } from "src/app/core/entities/productMenu";
import { CatalogService } from "src/app/core/services/catalog.service";
import { TreeviewLinkComponent } from "../treeview-link/treeview-link.component";
import { ProductService } from "src/app/core/services/product-service";
import { Configuracoes } from "src/app/core/entities/configuracoes";

@Component({
  selector: "app-treeview-link-dynamic-horizontal",
  styleUrls: ["./treeview-link-dynamic-horizontal.component.css"],
  templateUrl: "./treeview-link-dynamic-horizontal.component.html",
})
export class TreeviewLinkDynamicHorizontalComponent implements OnInit {
  @ViewChild("scrollContainer", { static: false }) scrollContainer: ElementRef;
  @ViewChildren(TreeviewLinkComponent)
  public submenu: QueryList<TreeviewLinkComponent>;
  @Output() breadCrumb = new EventEmitter<string>();
  @Output()
  public sendFilters = new EventEmitter<number[]>();
  @Input() hideNav = false;
  @Input() distance = 50;
  // @Input() caltalogFnc: any
  public filters: Set<number> = new Set();
  public rootFilters: Set<number> = new Set();
  public menu: ProductsMenu[];
  public loading: boolean = true;
  public lastSearch: string;
  public breadCrumb1: string;
  public currentItem: any = {};
  public height: number = 500;
  layoutMenu: number = 0;
  public API_IMAGENS: String;
  isTouchDevice: boolean;
  public mobile: boolean;
  public mobileLg: boolean;
  hoveredItem: any = null;
  maxElements = 5; // controla quantos itens exibir

  @HostListener("document:touchstart", ["$event"])
  onTouchStart(event: TouchEvent) {
    this.isTouchDevice = true;
  }

  @HostListener("document:mousedown", ["$event"])
  onMouseDown(event: MouseEvent) {
    if (!this.isTouchDevice) {
      this.isTouchDevice = false;
    }
  }
  @HostListener("window:resize", ["$event"])
  toggleDevice() {
    if (window.innerWidth < 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    if (window.innerWidth < 1400) {
      this.mobileLg = true;
    } else {
      this.mobileLg = false;
    }
  }
  constructor(
    private catalogService: CatalogService,
    public productService: ProductService
  ) {
    this.lastSearch = "";
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.layoutMenu = Configuracoes.layoutMenu;
    this.isTouchDevice = false;
  }

  ngOnInit() {
    this.catalogService.getMenu().subscribe((menu) => {
      this.menu = menu;
    });
  }
  mouseEnterEventHover(i) {
    if (!this.isTouchDevice) {
      let item = {
        ...i,
        children: i.children.sort(
          (a, b) => b.children.length - a.children.length
        ),
      };
      this.currentItem = i;
      return true;
    }
  }

  mouseEnterEvent(i) {
    if (this.isTouchDevice) {
      let ret = this.currentItem !== i;
      let item = {
        ...i,
        children: i.children.sort(
          (a, b) => b.children.length - a.children.length
        ),
      };
      this.currentItem = i;
      if (!ret) {
        this.currentItem = {};
      }
      if (i.children.length === 0) {
        return false;
      }
      return ret;
    }
  }

  public selectRoot(id: number, desc) {
    this.productService.filtro["menuIds"] = id;
    this.productService.menusIds = id;
    this.breadCrumb.emit(desc);
    // localStorage.setItem("selectedItem", JSON.stringify([{parent: desc}]))
    this.filters = new Set();
    this.submenu.forEach((c) => this.clear(c));
    this.sendFilters.emit([id]);
  }

  caltalogFnc() {
    this.productService.filtro = [];
    this.productService.menusIds = 0;
    this.productService.filtro["menuIds"] = [];
    this.breadCrumb.emit("");
    this.sendFilters.emit([]);
  }
  scrollLeft(): void {
    this.scrollContainer.nativeElement.scrollTo({
      left: this.scrollContainer.nativeElement.scrollLeft + 100,
      behavior: "smooth",
    });
  }

  imgSelect(link) {
    window.location.href = link;
  }
  public refreshMenu() {
    this.productService.filtro = [];
    // window.location.href="/catalogo"
  }

  scrollRight(): void {
    this.scrollContainer.nativeElement.scrollTo({
      left: this.scrollContainer.nativeElement.scrollLeft - 100,
      behavior: "smooth",
    });
  }
  private clear(item: TreeviewLinkComponent) {
    item.selected = false;
    item.submenu.forEach((i) => this.clear(i));
  }
  scroll(distance): void {
    const listWrapper = document.getElementById("list-items");
    listWrapper.scrollTo({ behavior: "smooth", left: distance });
  }

  public onSelect(data) {
    this.filters.clear();
    data.forEach((item) => {
      this.filters.add(item.id);
    });
    this.sendFilters.emit(Array.from(this.filters));
  }

  public addObjectWithoutDuplicates(newItem, array) {
    const isDuplicate = array.some(
      (item) => item.name === newItem.name || item.id === newItem.id
    );
    if (!isDuplicate) {
      return true;
    } else {
      return false;
    }
  }

  public setLocalStorage(it, desc) {
    let arr = [];
    // let flag = false
    arr = it.map((i) => ({ name: i.description, id: i.id }));

    // if (localStorage.getItem("selectedItem")) {
    //   let items = JSON.parse(localStorage.getItem("selectedItem"))
    //   for (let i = 0; i < items.length; i++) {
    //     if (items[i].parent === desc) {
    //       console.log(items[i])
    //       items[i].items.push(...arr);
    //       flag = true
    //     }
    //   }
    //   localStorage.setItem("selectedItem", JSON.stringify(items))
    //   if (!flag) {
    //     localStorage.setItem("selectedItem", JSON.stringify([...items, { parent: desc, items: arr }]))
    //   }
    // } else {
    // localStorage.setItem("selectedItem", JSON.stringify([{ parent: desc, items: arr }]))
    // }
  }

  public onClick(desc, data, item) {
    this.productService.filtro["menuIds"] = [item.id];
    this.setLocalStorage(data, desc);
    data.forEach((item) => {
      this.filters.add(item.id);
    });
    this.breadCrumb.emit(desc);
    this.sendFilters.emit([item.id]);
  }
  saveBc(b) {
    this.breadCrumb1 = b;
    // localStorage.setItem("selectedItem", b)
    this.breadCrumb.emit(b);
  }
  selectAll(desc, item) {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox: any) => {
      if (
        checkbox.checked &&
        checkbox.className === localStorage.getItem("lastWord") + "-check"
      ) {
        checkbox.dispatchEvent(new Event("change"));
      }
    });

    var botao: any = document.getElementsByClassName(desc + "-check");
    var eventoMudanca = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    // if(localStorage.getItem("lastWord")){
    //   var input: any = document.getElementsByClassName(localStorage.getItem("lastWord")+'-check');
    //   for(let i= 0; i < input.length; i++){
    //     if(input[i].className === localStorage.getItem("lastWord")+'-check'){
    //       input[i].dispatchEvent(eventoMudanca)
    //     }
    //   }
    // }

    // for(let i =0; i < document.getElementsByTagName("input").length;i++){
    //   if(document.getElementsByTagName("input")[i].type === "checkbox"){
    //     document.getElementsByTagName("input")[i].checked = false
    //   }
    // }
    // console.log(desc+'-check')

    localStorage.setItem("lastWord", desc);
    for (let i = 0; i < botao.length; i++) {
      if (botao[i].className === desc + "-check") {
        botao[i].dispatchEvent(eventoMudanca);
      }
    }
  }
}
